import { trStore } from "./tr.store";

export function trInitiateCheckout(content_ids: string[]) {
    trStore.add({
        event: "InitiateCheckout",
        data: { content_ids },
    });
}

export function trAddToCart(contents: [{ id: string; quantity: number }]) {
    trStore.add({
        event: "AddToCart",
        data: { contents },
    });
}
